/* eslint-disable */


import { api } from "../request/req.js"
import { xm, setCookie, getCookie } from '../utils/utils.js'
import { mapState, mapMutations, mapGetters } from 'vuex'
import Vue from 'vue'
import Head from './Head.vue';
import Foot from './Foot.vue';

function tip(e) {
  alert("Hãy kiểm tra lại số tài khoản và mật khẩu" || e.msg || 'error')
}

export default {
  name: 'Account',
  components: {
    Head, Foot
  },
  computed: {
    ...mapState(['userInfo', 'gameInfo', 'games']),
  },
  created() {
    this.setRem()
    if (this.isLogined()) {
      this.toHome()
    }
  },
  mounted() {
    // this.renderButton()
    this.initThird()

    for (let game of this.games) {
      if (game.id == this.gameInfo.id && game.appId == this.gameInfo.appId) {
        this.selGame(this.games.indexOf(game), true)
      }
    }
  },
  data() {
    return {
      see: false,
      account: '',
      password: '',
      selGameIndex: 0,
      showGames: 0,
    }
  },
  methods: {
    ...mapMutations(['loginLocal', 'logout', 'setGameInfo']),
    toHome() {
      xm.go('/pay');
    },
    selGame(index, isInit) {
      this.showGames = false
      if (this.selGameIndex == index) return
      this.selGameIndex = index
      this.setGameInfo(this.games[index])

      if (isInit) return
      this.createdGoogleLogin(this.getGoogleConfigId())
      FB.init({
        appId: this.getFbConfigId(),
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v13.0'
      });
      this.appleLogin(this.getAppleConfig());
    },
    setRem() {
      // const baseSize = 18
      // // 当前页面宽度相对于 1920宽的缩放比例，可根据自己需要修改。
      // const scale = Math.min(document.documentElement.clientWidth, 1920) / 1920
      // // 设置页面根节点字体大小（“Math.min(scale, 2)” 指最高放大比例为2，可根据实际业务需求调整）
      // document.documentElement.style.fontSize = baseSize * Math.min(scale, 2) + 'px'
    },
    initThird() {
      const google = document.createElement('script');
      google.type = 'text/javascript';
      google.src = 'https://accounts.google.com/gsi/client';
      google.onload = () => {
        this.createdGoogleLogin(this.getGoogleConfigId())
      }
      // google.async = true
      document.body.appendChild(google);


      const fb = document.createElement('script');
      fb.type = 'text/javascript';
      fb.src = 'https://connect.facebook.net/en_US/sdk.js';
      fb.async = true
      fb.defer = true
      fb.crossOrigin = 'anonymous'
      fb.onload = () => {
        FB.init({
          appId: this.getFbConfigId(),
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v20.0'
        });
      }
      document.body.appendChild(fb);

      const ap = document.createElement('script');
      ap.type = 'text/javascript';
      ap.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      ap.onload = () => {
        this.appleLogin(this.getAppleConfig());
      }
      document.body.appendChild(ap);
    },
    getAppId() {
      return this.games[this.selGameIndex].appId
    },
    getAppleConfig() {
      return this.gameInfo.apple
    },
    getFbConfigId() {
      return this.gameInfo.facebook.appId
    },
    getGoogleConfigId() {
      return this.gameInfo.google.clientId
    },
    login() {
      let param = {
        app_id: this.getAppId(),
        account: this.account,
        password: this.password,
        device_id: ''
      }
      api.login(param).then(d => {
        this.loginLocal(d)
        this.toHome()
      }).catch(e => {
        console.error(e)
        tip(e)
      })
    },
    checkLogin(cb) {
      if (!this.isLogined()) {
        return
      }
      cb()
    },
    isLogined() {
      return this.userInfo.token.length > 0
    },
    createdGoogleLogin(googleClientId) {
      google.accounts.id.initialize({
        client_id: googleClientId,
        callback: this.handleCredentialResponse
      });
      google.accounts.id.renderButton(
        document.getElementById("gg"),
        { theme: "outline", size: "large" }  // customization attributes
      );
      // google.accounts.id.prompt(); // also display the One Tap dialog
    },

    handleCredentialResponse(r) {
      console.log("123")
      api.googleLogin({
        app_id: this.getAppId(),
        id_token: r.credential
      }).then(d => {
        this.loginLocal(d)
        this.toHome()
      }).catch(e => {
        console.error(e)
        tip(e)
      })
    },
    appleLogin(config) {
      AppleID.auth.init(Object.assign({
        scope: "name email", // To tell apple we want the user name and emails fields in the response it sends us.
        state: "origin:web", // Any string of your choice that you may use for some logic. It's optional and you may omit it.
        usePopup: false, // Important if we want to capture the data apple sends on the client side.
      }, config));
    },
    tip(s) {
      alert(s)
    },
    fbLogin() {
      FB.getLoginStatus(response => {
        if (!response.session) {
          this.fb2login()
          return
        }

        FB.logout(r => {
          this.fb2login()
        })
      })
    },
    fb2login() {
      FB.login(r => {
        console.error('fb登录结果：', r)
        if (r.status === 'connected') {
          console.error('登录成功')
          api.facebookLogin({
            app_id: this.getAppId(),
            id_token: r.authResponse && r.authResponse.accessToken || ''
          }).then(d => {
            this.loginLocal(d)
            this.toHome()
          }).catch(e => {
            console.error(e)
            this.tip(e)
          })
        } else {
          this.tip('fail')
        }
      })
    }
  }
}
